import axios from 'axios'


export function getItems({ commit, state },props) {

    let params = {
        sortBy: props.pagination.sortBy,
        descending: props.pagination.descending,
        page: props.pagination.page,
        rowsPerPage: props.pagination.rowsPerPage,
        search: props.filter?.search,
        start_date: (props.filter && props.filter.dateRange && props.filter.dateRange.startDate) ? props.filter?.dateRange.startDate : '',
        end_date: (props.filter && props.filter.dateRange && props.filter.dateRange.endDate) ? props.filter?.dateRange.endDate : '',
    }
    return new Promise((resolve, reject) => {
        axios
            .post('/events/slots/getupcomingevents',params)
            .then(response => {
                resolve(response)
            })
            .catch(err => {
                reject(err)
            })
    })
}